<md-popup [popupClass]="'lesson-popup'" scrollStrategy="reposition">
	<div md-popup-target class="lesson-popup-target">
		<div class="scheduled-event-container">
			<div class="user-info">
				<lb-user-icon [userID]="userID()"></lb-user-icon>
			</div>
			<div class="lesson-status" [ngClass]="statusConfig[lessonStatus()].colorClass">
				<md-icon [icon]="statusConfig[lessonStatus()].icon"></md-icon>
			</div>
		</div>
	</div>
	<div md-popup-content>
		<ng-container
			*ngComponentOutlet="lessonCardComponent(); inputs: { lesson: lesson(), isPopup: true, displayedUser: lessonView(), detailsLink: detailsLink() }"
		></ng-container>
	</div>
</md-popup>
